/** Collapse stray spaces git inserts around `{old => new}` rename braces in numstat paths. */
export function normalizeGitDiffPath(path: string): string {
  return path.replace(/\\/g, '/').replace(/\/ +/g, '/').trim();
}
